import { payoutsService, customerService, invoiceService } from '@services';
import { isEmpty, uniq, isNil, keyBy } from 'lodash-es';

export default {
  fetchPayouts: async ({ commit, dispatch }, params = {}) => {
    try {
      const { data, total } = await payoutsService.list(params);

      await Promise.all([dispatch('fetchPayoutCustomers', { data }), dispatch('fetchPayoutInvoices', { data })]);

      commit('SET_PAYOUTS', data);
      commit('SET_TOTAL_PAYOUTS', total);
    } catch (error) {
      console.warn(error);
    }
  },
  async fetchPayoutCustomers({ commit }, { data }) {
    try {
      if (Array.isArray(data) && data.length > 0) {
        const customerIds = uniq(
          [
            ...data
              .filter(({ allocations }) => !isNil(allocations))
              .map(({ allocations }) => allocations.map(({ customerId }) => customerId))
              .flat(),
          ].filter(Boolean),
        );

        if (!isEmpty(customerIds)) {
          await customerService
            .list({
              companyId: this._vm.$auth.user()?.selectedCompany?.id,
              search: { ids: customerIds },
            })
            .then(({ list: customers }) => commit('SET_PAYOUTS_CUSTOMERS', keyBy(customers, 'id')));
        }
      }
    } catch ({ message }) {
      console.error(message);
    }
  },
  async fetchPayoutInvoices({ commit }, { data }) {
    try {
      if (Array.isArray(data) && data.length > 0) {
        const invoiceIds = uniq(
          [
            ...data
              .filter(({ allocations }) => !isNil(allocations))
              .map(({ allocations }) => allocations.map(({ invoiceIds }) => invoiceIds).flat())
              .flat(),
          ].filter(Boolean),
        );

        if (!isEmpty(invoiceIds)) {
          await invoiceService
            .list({
              companyId: this._vm.$auth.user()?.selectedCompany?.id,
              search: { ids: invoiceIds },
            })
            .then(({ list: invoices }) => commit('SET_PAYOUTS_INVOICES', keyBy(invoices, 'id')));
        }
      }
    } catch ({ message }) {
      console.error(message);
    }
  },
  exportPayouts: async ({}, params = {}) => {
    try {
      return await payoutsService.list(params);
    } catch (error) {
      console.warn(error);
    }
  },
  updatePayout: async ({}, params = {}) => {
    try {
      await payoutsService.update(params);
    } catch (error) {
      console.warn(error);
    }
  },
  fetchPayout: async ({}, params = {}) => {
    try {
      return await payoutsService.findOne(params);
    } catch (error) {
      console.warn(error);
    }
  },
  setSelected: ({ commit }, payload) => {
    commit('SET_SELECTED', payload);
  },
  updateTableOptions: ({ commit }, payload) => {
    commit('SET_TABLE_OPTIONS', payload);
  },
  resetTableOptions: ({ commit }) => {
    commit('RESET_TABLE_OPTIONS');
  },
};
